import { lazy } from "react";
import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";

import CheckAuth from "@/api/CheckAuth";
import AdminLayout from "../layout/AdminLayout";
import MembersPage from "../page/members/Page";
import MobilizationPage from "../page/mobilization/Page";
import SupplierPage from "../page/supplier/Page";
import ClientPage from "../page/client/Page";
import DashboardPage from "@/page/DashboardPage";
import ProjectPage from "../page/project/Page";
import TermsAndConditionPage from "../page/terms-and-conditions/Page";
import AddTermsAndCondition from "../page/terms-and-conditions/Add";
import EditTermsAndConditions from "../page/terms-and-conditions/Edit";
import TermsAndConditionViewOne from "../page/terms-and-conditions/ViewOne";
import QuotationPage from "../page/quotation/Page";
import ProjectViewOne from "../page/project/ViewOne";
import GenerateQuotation from "../page/quotation/Generate";
import EditQuotation from "../page/quotation/EditQuotation";
import QuotationViewOne from "../page/quotation/ViewOne";
import ArProfilePage from "../page/ar-profile/Page";
import CreateArProfile from "../page/ar-profile/Create";
import EditArProfile from "../page/ar-profile/Edit";

import OnboardSupplierPage from "../page/supplier/Onboard";

const ViewOnePayableInvoice = lazy(
    () => import("../page/invoice/payable/ViewOne"),
);
import ViewOneReceivableInvoice from "../page/invoice/receivable/ViewOne";
import ViewOneProjectPurchaseOrder from "../page/purchase-order/issued/project/ViewOne";
import ViewOneEquipmentPurchaseOrder from "../page/purchase-order/issued/equipment/ViewOne";
import ViewOneManPowerPurchaseOrder from "../page/purchase-order/issued/manpower/ViewOne";
import ApprovalSupplierPage from "../page/supplier/ApprovalPage";
import ViewOneReceivedPurchaseOrder from "../page/purchase-order/received/ViewOne";
import RouterErrorElement from "../page/error-element/ErrorElement";
import SalesEqnuiryAnaltyicsPage from "../page/sales-enquiry/Analtyics";

const ViewOneArEmployee = lazy(() => import("../page/ar-employee/ViewOne"));

const ReceivedPurchaseOrderPage = lazy(
    () => import("../page/purchase-order/received/Page"),
);

const AddGeneratePurchaseOrder = lazy(
    () => import("../page/purchase-order/issued/generate/Add"),
);

const EditGeneratePurchaseOrder = lazy(
    () => import("../page/purchase-order/issued/generate/Edit"),
);

const ManpowerPoPage = lazy(
    () => import("../page/purchase-order/issued/manpower/Page"),
);

const EquipmentPoPage = lazy(
    () => import("../page/purchase-order/issued/equipment/Page"),
);

const ProjectPoPage = lazy(
    () => import("../page/purchase-order/issued/project/Page"),
);

const SingleClient = lazy(() => import("@/v2/page/client/ViewOne"));
const AddDocumentPage = lazy(
    () => import("@/page/company-documents/AddDocumentPage"),
);
const CompanyDocuments = lazy(
    () => import("@/page/company-documents/CompanyDocuments"),
);
const SingleEmployee = lazy(() => import("@/v2/page/employee/ViewOne"));

const LoginPage = lazy(() => import("@/page/LoginPage"));
const SingleMobilization = lazy(() => import("@/v2/page/mobilization/ViewOne"));

const SingleSupplier = lazy(() => import("@/v2/page/supplier/ViewOne"));
const AccountPage = lazy(() => import("@/v2/page/user/Page"));
const SalesEnquiryPage = lazy(() => import("../page/sales-enquiry/Page"));
const ViewOneSalesEnquiry = lazy(() => import("../page/sales-enquiry/ViewOne"));
const ServiceAgreementPage = lazy(
    () => import("../page/service-agreement/Page"),
);
const ViewOneServiceAgreement = lazy(
    () => import("../page/service-agreement/ViewOne"),
);
const AssetsPage = lazy(() => import("../page/assets/Page"));
const AddSupplier = lazy(() => import("../page/supplier/Add"));
const EditSupplier = lazy(() => import("../page/supplier/Edit"));
const AddClient = lazy(() => import("../page/client/Add"));
const EditClient = lazy(() => import("../page/client/Edit"));
const ReceivablePage = lazy(() => import("../page/invoice/receivable/Page"));
const PayableInvoicePage = lazy(() => import("../page/invoice/payable/Page"));
const TimeSheetClientListPage = lazy(() => import("../page/time-sheet/Page"));
const ViewOneTimeSheet = lazy(() => import("../page/time-sheet/ViewOne"));
const CreateTimeSheet = lazy(() => import("../page/time-sheet/Create"));
const PerformancePage = lazy(() => import("../page/performance-tracker/Page"));
const EditMobilization = lazy(() => import("../page/mobilization/Edit"));
const AddMobilization = lazy(() => import("../page/mobilization/Add"));
const ArEmployeePage = lazy(() => import("../page/ar-employee/Page"));
const EmployeePage = lazy(() => import("../page/employee/Page"));

export const routes = createBrowserRouter([
    {
        path: "/",
        errorElement: <RouterErrorElement />,
        loader: CheckAuth,
        element: (
            <AdminLayout>
                <Outlet />
            </AdminLayout>
        ),
        children: [
            {
                index: true,
                element: <DashboardPage />,
            },
            {
                path: "/projects",
                children: [
                    {
                        index: true,
                        element: <ProjectPage />,
                    },
                    {
                        path: ":id",
                        element: <ProjectViewOne />,
                    },
                ],
            },
            {
                path: "/mobilization-database",
                children: [
                    {
                        index: true,
                        element: <MobilizationPage />,
                    },
                    {
                        path: "create",
                        element: <AddMobilization />,
                    },

                    {
                        path: "edit/:id",
                        element: <EditMobilization />,
                    },
                    {
                        path: ":id",
                        element: <SingleMobilization />,
                    },
                ],
            },
            {
                path: "/sales-enquiry",
                children: [
                    {
                        index: true,
                        element: <SalesEnquiryPage />,
                    },
                    {
                        path: "analtyics",
                        element: <SalesEqnuiryAnaltyicsPage />,
                    },
                    {
                        path: ":id",
                        element: <ViewOneSalesEnquiry />,
                    },
                ],
            },
            {
                path: "/service-agreement",
                children: [
                    {
                        index: true,
                        element: <ServiceAgreementPage />,
                    },

                    {
                        path: ":id",
                        element: <ViewOneServiceAgreement />,
                    },
                ],
            },
            {
                path: "/assets",
                children: [
                    {
                        index: true,

                        element: <AssetsPage />,
                    },
                    {
                        path: ":id",
                        element: <ViewOneServiceAgreement />,
                    },
                ],
            },
            {
                path: "/supplier-database",
                children: [
                    {
                        index: true,
                        element: <SupplierPage />,
                    },
                    {
                        path: "create",
                        element: <AddSupplier />,
                    },
                    {
                        path: "edit/:id",
                        element: <EditSupplier />,
                    },
                    {
                        path: ":id",
                        element: <SingleSupplier />,
                    },
                ],
            },
            {
                path: "/approve",
                children: [
                    {
                        index: true,
                        element: <Navigate to={"supplier"} />,
                    },
                    {
                        path: "supplier",
                        children: [
                            {
                                index: true,
                                element: <ApprovalSupplierPage />,
                            },
                            {
                                path: ":id",
                                element: <SingleSupplier approve={true} />,
                            },
                        ],
                    },
                ],
            },

            {
                path: "/client-database",
                children: [
                    {
                        index: true,
                        element: <ClientPage />,
                    },
                    {
                        path: "create",
                        element: <AddClient />,
                    },
                    {
                        path: "edit/:id",
                        element: <EditClient />,
                    },
                    {
                        path: ":id",
                        element: <SingleClient />,
                    },
                ],
            },
            {
                path: "/ar-employee-database",
                children: [
                    {
                        index: true,
                        element: <Navigate to="category/all" replace />,
                    },
                    {
                        path: "category/:tab",
                        element: <ArEmployeePage />,
                    },

                    {
                        path: ":id",
                        element: <ViewOneArEmployee />,
                    },
                ],
            },
            {
                path: "/quotation",
                children: [
                    {
                        index: true,
                        element: <QuotationPage />,
                    },
                    {
                        path: "create",
                        element: <GenerateQuotation />,
                    },
                    {
                        path: "edit/:id",
                        element: <EditQuotation />,
                    },
                    {
                        path: ":id",
                        element: <QuotationViewOne />,
                    },
                ],
            },

            {
                path: "/employee-database",
                children: [
                    {
                        index: true,
                        element: <Navigate to="category/all" replace />,
                    },
                    {
                        path: "category/:tab",
                        element: <EmployeePage />,
                    },
                    {
                        path: ":id",
                        element: <SingleEmployee />,
                    },
                ],
            },
            {
                path: "/issued-purchase-order",
                children: [
                    {
                        index: true,
                        element: (
                            <Navigate to="manpower-purchase-order" replace />
                        ),
                    },
                    {
                        path: ":type/edit/:id",
                        element: <EditGeneratePurchaseOrder />,
                    },
                    {
                        path: "generate",
                        children: [
                            {
                                index: true,
                                element: (
                                    <Navigate
                                        to="/issued-purchase-order/manpower-purchase-order"
                                        replace
                                    />
                                ),
                            },

                            {
                                path: ":type",
                                element: <AddGeneratePurchaseOrder />,
                            },
                        ],
                    },
                    {
                        path: "manpower-purchase-order",
                        children: [
                            {
                                index: true,
                                element: <ManpowerPoPage />,
                            },

                            {
                                path: ":id",
                                element: <ViewOneManPowerPurchaseOrder />,
                            },
                        ],
                    },
                    {
                        path: "equipments-purchase-order",
                        children: [
                            {
                                index: true,
                                element: <EquipmentPoPage />,
                            },

                            {
                                path: ":id",
                                element: <ViewOneEquipmentPurchaseOrder />,
                            },
                        ],
                    },
                    {
                        path: "project-purchase-order",
                        children: [
                            {
                                index: true,
                                element: <ProjectPoPage />,
                            },

                            {
                                path: ":id",
                                element: <ViewOneProjectPurchaseOrder />,
                            },
                        ],
                    },
                ],
            },
            {
                path: "/received-purchase-order",
                children: [
                    {
                        index: true,
                        element: <ReceivedPurchaseOrderPage />,
                    },
                    {
                        path: ":id",
                        element: <ViewOneReceivedPurchaseOrder />,
                    },
                ],
            },
            {
                path: "/invoice-tracker",
                children: [
                    {
                        index: true,
                        element: (
                            <Navigate
                                to="/invoice-tracker/payable-invoice"
                                replace
                            />
                        ),
                    },
                    {
                        path: "payable-invoice",
                        children: [
                            {
                                index: true,
                                element: <PayableInvoicePage />,
                            },
                            {
                                path: ":id",
                                element: <ViewOnePayableInvoice />,
                            },
                        ],
                    },
                    {
                        path: "receivable-invoice",
                        children: [
                            {
                                index: true,
                                element: <ReceivablePage />,
                            },
                            {
                                path: ":id",
                                element: <ViewOneReceivableInvoice />,
                            },
                        ],
                    },
                ],
            },
            {
                path: "/templates",
                children: [
                    {
                        index: true,
                        element: (
                            <Navigate
                                to="/templates/terms-and-conditions"
                                replace
                            />
                        ),
                    },
                    {
                        path: "terms-and-conditions",
                        children: [
                            {
                                index: true,
                                element: <TermsAndConditionPage />,
                            },
                            {
                                path: "create",
                                element: <AddTermsAndCondition />,
                            },
                            {
                                path: "edit/:id",
                                element: <EditTermsAndConditions />,
                            },
                            {
                                path: ":id",
                                element: <TermsAndConditionViewOne />,
                            },
                        ],
                    },
                ],
            },
            {
                path: "/company-documents",
                children: [
                    {
                        index: true,
                        element: <CompanyDocuments />,
                    },
                    {
                        path: "create",
                        element: <AddDocumentPage />,
                    },
                    {
                        path: "edit/:id",
                        element: <div>Company Document Edit Page</div>,
                    },
                ],
            },

            {
                path: "time-sheet",
                children: [
                    {
                        index: true,
                        element: <Navigate to={"/time-sheet/generate"} />,
                    },
                    {
                        path: "project/:projectId/supplier/:supplierId",
                        element: <ViewOneTimeSheet />,
                    },
                    {
                        path: "project/:projectId/supplier/:supplierId/:status",
                        element: <CreateTimeSheet />,
                    },
                    {
                        path: ":tab",
                        element: <TimeSheetClientListPage />,
                    },
                ],
            },
            {
                path: "performance-tracker",
                element: <PerformancePage />,
            },

            {
                path: "account",
                children: [
                    {
                        index: true,
                        element: <AccountPage />,
                    },
                    { path: "company-details", element: <ArProfilePage /> },
                    {
                        path: "company-details/create",
                        element: <CreateArProfile />,
                    },
                    {
                        path: "company-details/edit/:id",
                        element: <EditArProfile />,
                    },
                ],
            },
            {
                path: "members",
                children: [
                    {
                        index: true,
                        element: <MembersPage />,
                    },
                ],
            },

            { path: "*", element: <p>Page Not Found</p> },
        ],
    },

    {
        path: "/login",
        loader: CheckAuth,
        element: <LoginPage />,
    },
    {
        path: "/supplier/onboard/:id",
        element: <OnboardSupplierPage />,
    },
    {
        path: "*",
        element: "Not Found",
    },
]);
